/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Spotting_Event_Group_HelpInputs */



/**
* | output |
* | --- |
* | "The Spotting List will normally contain your subtitles with dialogue and speaker information." |
*
* @param {Ccsl_Export_Spotting_Event_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_spotting_event_group_help = /** @type {((inputs?: Ccsl_Export_Spotting_Event_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Spotting_Event_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La liste de reperage contient generalement vos sous-titres avec dialogue et informations de locuteur.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Sprecherliste enthält normalerweise Ihre Untertitel mit Dialog- und Sprecherinformationen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Di solito, l'elenco di individuazione conterrà i sottotitoli con informazioni sui dialoghi e sull'oratore.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В списке для опознания обычно содержатся ваши субтитлы с информацией о диалогах и говорящих.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La lista de localización normalmente contendrá subtítulos con diálogos e información del orador.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕列表通常会包含对话和说话人信息等字幕内容。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スポッティング リストには通常、会話と話者の情報を含む字幕が含まれます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पॉटिंग लिस्ट में आमतौर पर संवाद और वक्ता की जानकारी सहित आपके उपशीर्षक शामिल होंगे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A lista de identificação de atores geralmente contém as legendas com informações sobre os diálogos e os falantes.")
	return /** @type {LocalizedString} */ ("The Spotting List will normally contain your subtitles with dialogue and speaker information.")
});